import React, { useState } from "react";
import { useEffect } from "react";
import styled from "styled-components";
import tablet from "../images/tablet.png";
import ItemSearch from "../components/search-box";

const Info = styled.div`
  display: flex;
  div:first-child {
    flex: 1;
  }
  div:nth-child(2) {
    padding-left: 25px;
    flex: 5;
  }
`;
const AuditText = styled.div`
  color: red;
  text-align: center;
  margin-top: 5px;
`;

const SearchContainer = styled.div`
  text-align: center;
  margin: 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  h2 {
    text-align: right;
    margin-right: 10px;
  }
`;

const DropDown = styled.select`
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  min-width: 200px;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  padding-top: 5px;
  justify-content: space-between;
`;

const Button = styled.a`
  padding: 13px 26px;
  color: #fff;
  background-color: #272727;
  border-color: #272727;
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 600;
  font-style: normal;
  line-height: 1;
  border-radius: 300px;
  text-decoration: none;
`;

const Home = () => {
  const currentCalendarYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  let currentFY;
  if (currentMonth >= 6) {
    //July starts new FY, add 1
    currentFY = currentCalendarYear + 1;
  } else {
    currentFY = currentCalendarYear;
  }
  const [year, setYear] = useState(currentFY);
  const [years, setYears] = useState([]);

  useEffect(() => {
    const fetchYears = async () => {
      try {
        const response = await fetch("/Home");
        const data = await response.json();
        setYears(data);
      } catch (error) {
        console.error("Error fetching years: ", error);
      }
    };

    fetchYears();
  }, []);

  return (
    <div>
      <Info>
        <div>
          <img src={tablet} alt="tablet" />
        </div>
        <div>
          <p>
            Welcome to the Town of Marana’s financial transparency database. The
            Town of Marana financial transparency database provides information
            from the Marana Financial System, which enables a clear view of the
            government’s operations. In addition, it provides an interactive
            application to browse searchable expenditure data, vendor payments,
            and revenue data in the last three fiscal years and through the most
            recent quarter of the current fiscal year.
          </p>
          <p>
            Our goal is to continuously improve this website and we welcome your
            feedback, comments and questions. If you have questions about a
            transaction or want to provide feedback, please contact the Finance
            Department at 520-382-1900 or&#160;
            <a href="mailto:financemgr@maranaAZ.gov">financemgr@maranaAZ.gov</a>
            .
          </p>
        </div>
      </Info>
      <AuditText></AuditText>
      <SearchContainer>
        <h2>Search</h2>
        <ItemSearch />
      </SearchContainer>
      <SearchContainer>
        <h2>Browse By Year</h2>
        <DropDown onChange={(e) => setYear(e.target.value)} value={year}>
          <option value="">---- select a year ----</option>
          {/* <option value="2023">2023</option>
          <option value="2024">2024</option>
          <option value="2025">2025</option>
          <option value="2026">2026</option> */}
          {years.map((yearOption, index) =>
            yearOption.fYear >= currentFY - 3 &&
            yearOption.fYear <= currentFY ? (
              <option key={index} value={yearOption.fYear}>
                {yearOption.fYear}
              </option>
            ) : (
              ""
            ),
          )}
        </DropDown>
        {year && <div>-- Select a category below --</div>}
      </SearchContainer>
      {year && (
        <ButtonContainer>
          <Button href={`/department/${year}`}>SPENDING BY DEPARTMENT</Button>
          <Button href={`/vendor/${year}`}>SPENDING BY VENDOR</Button>
          <Button href={`/revenue/${year}`}>REVENUE BY SOURCE</Button>
        </ButtonContainer>
      )}
    </div>
  );
};

export default Home;
